import React from "react";
import { useParams } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    // // backgroundColor: "#eee",
    // padding: theme.spacing(4),
    height: `calc(100% - 48px)`,
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
  },

  chatPapper: {
    display: "flex",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
  },

  contactsWrapper: {
    display: "flex",
    height: "100%",
    width: 390,
    minWidth: 340,
    maxWidth: "42vw",
    flexDirection: "column",
    overflowY: "hidden",
    borderRight: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("sm")]: {
      width: 330,
      minWidth: 300,
      maxWidth: "46vw",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      minWidth: 0,
      maxWidth: "none",
    },
  },
  contactsWrapperSmall: {
    display: "flex",
    height: "100%",
    width: 390,
    minWidth: 340,
    maxWidth: "42vw",
    flexDirection: "column",
    overflowY: "hidden",
    borderRight: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("sm")]: {
      width: 320,
      minWidth: 290,
      maxWidth: "44vw",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    minWidth: 0,
    flex: 1,
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      display: props => (props.ticketId ? "flex" : "none"),
    },
  },
  welcomeMsg: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
  },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const Chat = () => {
  const { ticketId } = useParams();
  const classes = useStyles({ ticketId });

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
          <div
            className={
              ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <TicketsManager />
          </div>
          <div className={classes.messagessWrapper}>
            {ticketId ? (
              <Ticket />
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg}>
                  <span>{i18n.t("chat.noTicketMessage")}</span>
                </Paper>
              </Hidden>
            )}
          </div>
      </div>
    </div>
  );
};

export default Chat;
